import { Label, Textarea } from "@altimateai/lego";

interface MarkdownContentSectionProps {
  markdownContent: string;
  setMarkdownContent: (value: string) => void;
}

export function MarkdownContentSection({
  markdownContent,
  setMarkdownContent,
}: MarkdownContentSectionProps) {
  return (
    <div>
      <Label htmlFor="markdown">
        Markdown Content <span className="al-text-red-500">*</span>
      </Label>
      <Textarea
        id="markdown"
        value={markdownContent}
        onChange={e => setMarkdownContent(e.target.value)}
        placeholder="# My Documentation&#10;&#10;Enter your markdown content here..."
        rows={15}
        className="al-font-mono al-text-sm"
      />
    </div>
  );
}
